import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Breadcrumb, BreadcrumbItem, Button, Tile } from 'carbon-components-react';
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';
import SetFrequency from './SetFrequency';
import AddTask from './AddTask';
import moment from 'moment';
import AddDuration from './AddDuration';
import { BasicInfo } from './BasicInfo';
import { RecommendResource } from './RecommendResource';
import { ReviewSubmit } from './ReviewSubmit';
import i18n from "../../i18n";
import callGetApi from '../../requests/GetRequests';
import callPostApi from '../../requests/PostRequests';
import * as Constants from '../../requests/URLConstants';


const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%'
    },
    button: {
        marginRight: theme.spacing(1),
    },
}));



export function CustomizedSteppers() {
    var rowsArray = [];
    var rowsClient = [];
    var rowsTech = [];
    var rowsAutomata = [];
    var rowsApplicationServer = [];
    var rowsAppStack = [];
    var rowsArrayTaskCompletion = [];
    var rowsApplicationStack = [];

    const classes = useStyles();
    const [ntext, setntext] = useState('');
    const [activeStep, setActiveStep] = useState(0);
    const [onboardAutomata, setOnBoardAutomata] = useState('');
    const [automataExecutionTime, setAutomataExecutionTime] = useState('');
    const steps = getSteps();
    const home = i18n.t('manageschedule.Home');
    const addSchedule = i18n.t('manageschedule.AddSchedule');
    const [consolidatedTime, setStartTimeFormat] = useState('');
    const [endTimeFormat, setEndTimeFormat] = useState('');
    const [formIsValid, setformIsValid] = useState(true);
    const [selectedSubmit, setselectedSubmit] = useState(true);
    const [recommendResourceCheck, setrecommendResourceCheck] = useState(false);
    const [schedule, setSchedule] = useState('');
    const [description, setDescription] = useState('');
    const [between_start_time, setbetween_start_time] = useState(new Date('2014-08-18T00:00:00'));
    const [between_end_time, setbetween_end_time] = useState(new Date('2014-08-18T23:59:59'));
    const [rb, setrb] = useState('');
    const [ss, setss] = useState('');
    const [tb, settb] = useState('');
    const [oa, setoa] = useState('');
    const [bs, setbs] = useState('');
    const [data, setData] = useState([]);
    const [flag, setFlag] = useState(false);
    const [open, setOpen] = useState(false);
    const [helptext_appstackname, sethelptext_appstackname] = useState('');
    const [valid_appstackname, setvalidappstackname] = useState(false);
    const [timeFilterSelections, setTimeFilterSelections] = useState({});
    const [tasksArray, setTasksArray] = useState([
        {
            taskName: "", taskDescription: "", taskCompletion: "", taskException: "", successScenario: "", failureScenario: "", isInitialTask: true, helptext_taskname: "", helptext_taskdesc: "", helptext_success: "", helptext_fail: "",
            valid_taskName: false, valid_taskDescription: false, valid_successScenario: false, valid_failureScenario: false,
            postCompletionDelay: 0, valid_postCompletionDelay: false, helptext_postCompletionDelay: "", fail_fast_on_any_errors: false,
            automataArray: [{
                automataName: "", time: "", timeDelay: 0, execution_time: 0, automataThreadCount: 1, resourceName: "", resourceDropdown: [], helptext_dur: "", helptext_automataname: "",
                helptext_automataduration: "", helptext_resourcename: "", valid_automataName: false, valid_resourceName: false, valid_dur: false, resourceLoader: false,
                startUpParamArray: [{
                    startUpParamName: "", startUpParamValue: "", helptext_startUpParamName: "", valid_startUpParamName: false, helptext_startUpParamValue: "", valid_startUpParamValue: false,
                }]
            }]
        }]);
    const [delay, setDelay] = useState();
    const [time, setTime] = useState();

    // const [taskDescription, setTaskDescription] = useState();

    const [client, setclient] = useState('');
    const [technology, settechnology] = useState('');
    const [franchise, setfranchise] = useState('');
    const [RowsFranchise, setRowsFranchise] = useState([{}]);
    const [RowsClient, setRowsClient] = useState([{}]);
    const [RowsApplicationServer, setRowsApplicationServer] = useState([{}]);
    const [RowsApplicationStack, setRowsApplicationStack] = useState([{}]);
    const [RowsAppStack, setRowsAppStack] = useState([{}]);
    const [RowsTech, setRowsTech] = useState([{}]);
    const [RowsAutomata, setRowsAutomata] = useState([{}]);
    const Once = i18n.t('editScheduleRecommendation.once');
    const Hourly = i18n.t('editScheduleRecommendation.hourly');
    const Daily = i18n.t('editScheduleRecommendation.daily');
    const Weekly = i18n.t('editScheduleRecommendation.weekly');
    const Monthly = i18n.t('editScheduleRecommendation.monthly');
    const Yearly = i18n.t('editScheduleRecommendation.yearly');
    const Minutely = i18n.t('editScheduleRecommendation.minutely');
    const Monday = i18n.t('editScheduleRecommendation.monday');
    const First = i18n.t('editScheduleRecommendation.First');
    const Cancel = i18n.t('editScheduleRecommendation.Cancel');
    const Back = i18n.t('editScheduleRecommendation.Back');
    const Next = i18n.t('editScheduleRecommendation.Next');







    const [occurances, setOccurances] = useState(
        [Once, Minutely, Hourly, Daily, Weekly, Monthly, Yearly]
    );
    const [frequency, setFrequency] = useState(
        ['1', '2', '3', '4', '5', '6', '7']
    );
    const [numberOfTasks, setNumberOfTasks] = useState(1);
    const [numberOfAutomata, setNumberOfAutomata] = useState(0);


    const [taskCompletion, setTaskCompletion] = useState([{}]);
    const [taskException, setTaskException] = useState(
        [{}]
    );
    const [hide, setHide] = useState(true);
    const [hideBack, setHideBack] = useState(true);
    const [currentOccurance, setCurrentOccurances] = useState();
    const [currentFrequency, setCurrentFrequency] = useState();
    const [currentTaskCompletion, setcurrentTaskCompletion] = useState();
    const [currentTaskException, setcurrentTaskException] = useState();
    const [currentAutomata, setCurrentAutomata] = useState([
        {
            time: '', timeDelay: 0, automataName: ""
        }
    ]);
    const [timeDelay, setTimeDelay] = useState();
    const [checked, setChecked] = useState(false);
    const [checkedInitalTask, setCheckedInitalTask] = useState(false);
    const [checkedFailFast, setCheckedFailFast] = useState(false);
    const [applicationServer, setApplicationServer] = useState("");

    const [frequencyWeek, setFrequencyWeek] = useState("dateday");
    const [frequencyWeekDay, setFrequencyWeekDay] = useState({ Monday });
    const [frequencyValue, setFrequencyValue] = useState("1");
    const [appStack, setAppStack] = useState();
    // const [frequencyWeek, setFrequencyWeek] = useState();
    // const [frequencyWeekDay, setFrequencyWeekDay] = useState();
    const [calendarDropdown, setCalendarDropdown] = useState([{}]);
    const [radiobuttonvalue, setRadiobuttonvalue] = useState();
    const [radiobuttonvalueweekly, setRadiobuttonvalueweekly] = useState();
    const [monthlyStartDate, setMonthlyStartDate] = useState();
    const [calendarName, setCalendarName] = useState();
    const [calendarNameOptions, setCalendarNameOptions] = useState({ First });
    const [automataFrequency, setAutomataFrequency] = useState({ Daily });
    const [helptextAutomataFrequency, setHelptextAutomataFrequency] = useState('');
    const [dropdownFlag1, setDropdownFlag1] = useState(false);
    const [radioweeklyFlag1, setRadioweeklyFlag1] = useState(false);
    const [radioweeklyFlag2, setRadioweeklyFlag2] = useState(false);
    const [calendarChecked, setCalendarChecked] = useState(false);
    const [selectFlagCalendar, setSelectFlagCalendar] = useState(true);
    const [selectFlag, setSelectFlag] = useState(true);
    const [calendarcheckedvalueflag, setCalendarcheckedvalueflag] = useState(true);
    const [dropdownWeeklyFlag, setDropdownWeeklyFlag] = useState(true);
    const [everyTextboxFlag, setEveryTextboxFlag] = useState(false);
    const [dropdownFlag, setDropdownFlag] = useState(false);
    const [dropdownFlagCalendar, setDropdownFlagCalendar] = useState(false);
    const [valid_sdate, setvalid_sdate] = useState(false);
    const [valid_stime, setvalid_stime] = useState(false);
    const [valid_etime, setvalid_etime] = useState(false);

    const [noresult, setnoresult] = useState(false);
    const [helptext_monthly, sethelptext_monthly] = useState("");
    const [helptext_freq, sethelptext_freq] = useState("");
    const [helptext_scheduledesc, sethelptext_scheduledesc] = useState("");
    const [helptext_auto, sethelptext_auto] = useState("");
    const [helptext_edate, sethelptext_edate] = useState("");
    const [helptext_sdate, sethelptext_sdate] = useState("");
    const [helptext_etime, sethelptext_etime] = useState("");
    const [helptext_stime, sethelptext_stime] = useState("");
    const [helptext_schedulename, sethelptext_schedulename] = useState("");
    const [valid_schedulename, setvalid_schedulename] = useState(false);

    const [valid_freq_value, setvalid_freq_value] = useState(false);
    const [valid_scheduledesc, setvalid_scheduledesc] = useState(false);
    const [valid_edate, setvalid_edate] = useState(false);
    const [valid_auto, setvalid_auto] = useState(false);
    const [helptext_dur, sethelptext_dur] = useState('');
    const [frequencytext, setFrequencytext] = useState(i18n.t('scheduleRecommendation.day(s)'));

    const [helptext_apphostname, sethelptext_apphostname] = useState('');
    const [helptext_clientname, sethelptext_clientname] = useState('');
    const [helptext_franchisename, sethelptext_franchisename] = useState('');
    const [helptext_technology, sethelptext_technology] = useState('');
    const [valid_technology, setvalid_technology] = useState(false);

    const [valid_clientname, setvalid_clientname] = useState(false);
    const [valid_franchisename, setvalid_franchisename] = useState(false);

    const [valid_apphostname, setvalid_apphostname] = useState(false);
    const [helptext_automata_frequency, sethelptext_automata_frequency] = useState('');


    // useEffect(() => {
    //     handleChangefranchise();                                                                        
    //   }, [franchise])



    useEffect(() => {
        getItemsTaskCompletion();
    }, [numberOfTasks, numberOfAutomata]);
    // useEffect(() => {
    //     getItemsTaskCompletion();
    // }, [numberOfTasks, numberOfAutomata]);

    useEffect(() => {
        renderNewAutomata()
    }, [numberOfAutomata])


    useEffect(() => {
        callGetApi(Constants.POSTAPPSTACK, { 'Content-Type': 'application/json' })
            .then(res => {
                res.forEach(function (element) {
                    let taskobject = {};
                    taskobject['appstack_desc'] = element["appstack_desc"];
                    taskobject['appstack_id'] = element["appstack_id"];
                    taskobject['appstack_nm'] = element["appstack_nm"];
                    taskobject['crt_btch_id'] = element["crt_btch_id"];
                    taskobject['rcrd_crt_dt'] = element["rcrd_crt_dt"];
                    taskobject['updt_btch_id'] = element["updt_btch_id"];
                    taskobject['rcrd_updt_dt'] = element["rcrd_updt_dt"];
                    rowsAppStack.push(taskobject);
                })
                setRowsAppStack(rowsAppStack);
            })
            .catch(err => {
            })

        callPostApi(Constants.POSTAPPLICATIONHOST, { 'Content-Type': 'application/json' })
            .then(res => {
                res.forEach(function (element) {
                    let taskobject = {};
                    taskobject['key'] = element["key"];
                    rowsApplicationServer.push(taskobject);
                })
                setRowsApplicationServer(rowsApplicationServer);
            })
            .catch(err => {
            })

        callGetApi(Constants.CODEQUALITYCHECKFRANCHISE,
            { 'Content-Type': 'application/json' },
            {}
        )
            .then(res => {
                res.forEach(function (element) {
                    let taskobject = {};
                    taskobject['key'] = element["key"];
                    rowsArray.push(taskobject);

                })
                setRowsFranchise(rowsArray);

            })
            .catch(err => {
                // if (err.response.status == 401) {
                //   localStorage.removeItem("token");
                //   localStorage.removeItem("expires_in");
                //   localStorage.removeItem("username");
                //   localStorage.removeItem("refresh_token");

                //   window.location.href = "/";
                // }
                //toast.error(uploadError);
            });
        callGetApi(Constants.CODEQUALITYCHECKTECHNOLOGY,
            { 'Content-Type': 'application/json' },

        )
            .then(res => {
                res.forEach(function (element) {
                    let taskobject = {};
                    taskobject['key'] = element["tclgy_nm"];
                    rowsTech.push(taskobject);

                })
                setRowsTech(rowsTech);

            })
            .catch(err => {
                // if (err.response.status == 401) {
                //   localStorage.removeItem("token");
                //   localStorage.removeItem("expires_in");
                //   localStorage.removeItem("username");
                //   localStorage.removeItem("refresh_token");

                //   window.location.href = "/";
                // }
                //toast.error(uploadError);
            });
        callGetApi(Constants.CODEQUALITYCHECKCLIENT,
            { 'Content-Type': 'application/json' },
            {}
        )
            .then(res => {
                res.forEach(function (element) {
                    let taskobject = {};
                    taskobject['key'] = element["key"];
                    rowsClient.push(taskobject);

                })
                setRowsClient(rowsClient);

            })
            .catch(err => {

                //toast.error(uploadError);
            });




    }, []);


    function ResourceNameChange(selectedItem, index, aindex) {
        let tasksArrayClone = [...tasksArray];
        tasksArrayClone[index].automataArray[aindex].resourceName = selectedItem;
        setTasksArray(tasksArrayClone)
    }

    async function handleRecommendedresource(e, index, aindex) {
        // e.preventDefault();
        setrecommendResourceCheck(true)
        // setAutomataIndex(aindex)
        // setTaskIndex(index)
        //   this.clearAllField(e);
        //execution_time== timeDelay
        //postcompletiondelay==time
        if (tasksArray[index].automataArray[aindex].timeDelay !== 0) {
            let consolidatedTime = moment(timeFilterSelections.startTime);
            const copyAutomataArrayB = Object.assign([], tasksArray[index].automataArray);
            copyAutomataArrayB[aindex].resourceDropdown = [];
            let tasksArrayClone = [...tasksArray];
            tasksArrayClone[index].automataArray = copyAutomataArrayB;
            setTasksArray(tasksArrayClone)
            let minutes = 0;
            for (var i = 0; i <= aindex; i++) {
                minutes += tasksArray[index].automataArray[i].timeDelay;
            }
            let startTimeFormat = timeFilterSelections.startDate + " " + timeFilterSelections.startTime;
            // consolidatedTime = new Date((startTimeFormat) + minutes * 60000);
            consolidatedTime = moment().format('MM/DD/YYYY h:mm:ss');
            let endTimeFormat = timeFilterSelections.endDate + + " " + timeFilterSelections.endTime;
            endTimeFormat = moment().format('MM/DD/YYYY h:mm:ss');
            setEndTimeFormat(endTimeFormat)

            // consolidatedTime = new Date(new Date(timeFilterSelections.startTime).getTime() + minutes * 60000);
            //console.log(i18n.t('scheduleRecommendation.consolidatedtimeMessage') + consolidatedTime);
            consolidatedTime = moment(consolidatedTime).toISOString();
            setStartTimeFormat(consolidatedTime)
            //console.log(i18n.t('scheduleRecommendation.consolidatedtimeISOMessage') + consolidatedTime);
            setOnBoardAutomata(tasksArray[index].automataArray[aindex].key);
            setAutomataExecutionTime(tasksArray[index].automataArray[aindex].timeDelay)
            let inp = {
                onboard_automata_name: tasksArray[index].automataArray[aindex].key//automataName
                , onboard_life_start_time: consolidatedTime
                , onboard_life_end_time: moment(endTimeFormat).toISOString()
                , automata_execution_time: tasksArray[index].automataArray[aindex].timeDelay
                , onboard_automata_frequency: currentOccurance.toLowerCase()//TBD
                , frequency_value: frequencyValue// TBD
                , range_time_start: moment(between_start_time).format('HH:mm:ss')//TBD
                , range_time_end: moment(between_end_time).format('HH:mm:ss')//TBD
                , TopNBots: 5
                , acct_type_name: franchise.key
                , franchise_name: franchise.key
                , apphost_name: applicationServer.key
                , appstack_name: ""
                , client_name: client.key === undefined ? '' : client.key
            };
            tasksArray[index].automataArray[aindex].resourceLoader = true;
            let res = await callPostApi(Constants.RECOMMENDRESOURCE, { 'Content-Type': 'application/json' },
                JSON.stringify(inp))
            //console.log(res);
            //      .then(response => {
            //     if (response.status === 401) {
            //         tasksArray[index].automataArray[aindex].resourceLoader = false;
            //     }
            //     return response.json();
            // })
            //    .then(res => {
            var element = []
            //console.log(res);
            if (res.Message === undefined) {
                //console.log(res.RecommendedBots.length)
                if (res.RecommendedBots.length === 0) {
                    tasksArray[index].automataArray[aindex].resourceLoader = false;
                    const copyAutomataArray = Object.assign([], tasksArray[index].automataArray);
                    copyAutomataArray[aindex].resourceLoader = false;
                    // this.setState({ data: element })
                    let tasksCloneArray = [...tasksArray];
                    tasksCloneArray[index].automataArray = copyAutomataArray;
                    setTasksArray(tasksCloneArray)
                    setnoresult(true);
                    setntext("no result found");
                } else {
                    tasksArray[index].automataArray[aindex].resourceLoader = false;
                    for (var i = 0; i < res.RecommendedBots.length; i++) {
                        element.push(res.RecommendedBots[i]);
                    }
                    setFlag(true)
                    const copyAutomataArray = Object.assign([], tasksArray[index].automataArray);
                    copyAutomataArray[aindex].resourceDropdown = element;
                    let tasksArrayClone = [...tasksArray];
                    tasksArrayClone[index].automataArray = copyAutomataArray;
                    setTasksArray(tasksArrayClone);
                    setrb(res.RecommendedBots)
                    setss(res.ScoreSignificance)
                    settb(res.TopNBots)
                    setoa(res.onboard_automata_name)
                    setbs(res.respectiveBotsScore)
                    // this.setState({ resourceDropdown });
                }
            } else {
                const copyAutomataArray = Object.assign([], tasksArray[index].automataArray);
                copyAutomataArray[aindex].resourceLoader = false;
                let tasksCloneArray = [...tasksArray];
                tasksCloneArray[index].automataArray = copyAutomataArray;
                setTasksArray(tasksCloneArray);
                setnoresult(true);
                setntext("no results found")
            }
            // }).catch(error => {
            //     const copyAutomataArray = Object.assign([], tasksArray[index].automataArray);
            //     copyAutomataArray[aindex].resourceLoader = false;
            //     // this.setState({ data: element })
            //     let tasksArrayClone = [...tasksArray];
            //     tasksArrayClone[index].automataArray = copyAutomataArray;
            //     setTasksArray(tasksArrayClone);
            //     //tasksArray[index].automataArray[aindex].resourceLoader = false;
            //     console.log(error);
            // });
            setrecommendResourceCheck(false)
        } else {
            // this.handleValidation(index, aindex);
            // alert("Form has errors.")
            setOpen(true)
        }
    }
    function getItemsTaskCompletion(deleted) {

        const Tasklength = numberOfTasks;
        for (var i = 1; i <= Tasklength; i++) {
            rowsArrayTaskCompletion.push({ key: i + '' })


        }
        rowsArrayTaskCompletion.push({ key: 'Stop' })
        rowsArrayTaskCompletion.push({ key: 'Abort' })
        var index = rowsArrayTaskCompletion.indexOf(deleted);
        if (index !== -1) {
            rowsArrayTaskCompletion.splice(index, 1);
        }

        setTaskCompletion(rowsArrayTaskCompletion);

    }
    // function renderNewTask() {
    //     let count = numberOfTasks;
    //     count = count + 1;
    //     setNumberOfTasks(count)
    // }

    function renderNewTask() {
        let taskCount = numberOfTasks;
        taskCount = taskCount + 1;
        const copyTaskArray = [...tasksArray];
        copyTaskArray.push({
            taskAddid: taskCount, taskName: "", valid_taskName: false, time: "", timeDelay: "", taskDescription: "", successScenario: "", failureScenario: "", isInitialTask: false, postCompletionDelay: 0, fail_fast_on_any_errors: false,
            automataArray: [{
                automataName: "", time: "", timeDelay: 0, execution_time: 0, automataThreadCount: 1, resourceName: "", resourceDropdown: [], helptext_dur: "", helptext_automataname: "",
                helptext_automataduration: "", helptext_resourcename: "", valid_automataName: false, valid_resourceName: false, valid_dur: false, resourceLoader: false,
                startUpParamArray: [{
                    startUpParamName: "", startUpParamValue: "", helptext_startUpParamName: "", valid_startUpParamName: false, helptext_startUpParamValue: "", valid_startUpParamValue: false,
                }]
            }]
        })
        setTasksArray(copyTaskArray)
        setNumberOfTasks(copyTaskArray.length)
        // e.preventDefault();

    }


    function renderNewAutomata() {
        let count = currentAutomata.length;
        count = count + 1;
        setNumberOfAutomata(count)
    }


    function handleCheckedInitialTask(e, index) {
        let tasksArrayClone = [...tasksArray];
        // var taskid = e.target.id
        tasksArrayClone[index].isInitialTask = e
        setTasksArray(tasksArrayClone);
        validateForm();

        // setCheckedInitalTask(!checkedInitalTask)
    }
    function handleCheckedFailFast(e, index) {
        let tasksArrayClone = [...tasksArray];
        // var taskid = e.target.id
        tasksArrayClone[index].fail_fast_on_any_errors = e
        setTasksArray(tasksArrayClone);
        validateForm();

        // setCheckedFailFast(!checkedFailFast)
    }
    function getAutomataRecords(franchise, client) {
        //console.log(franchise + "---" + client);
        let inp = {};
        if (client !== "" && client !== null && client !== "undefined") {
            inp = {
                franchise: franchise.key,
                clientName: client.key.trim()
            };
        } else {
            inp = {
                franchise: franchise.key,
                clientName: ""
            };
        }
        // const bodyJSON = {
        //     "franchise": franchise.key,
        //     "client": client.key
        // }
        callPostApi(Constants.POSTUNIQUEAUTOMATA, { 'Content-Type': 'application/json' }
            , inp)
            .then(res => {
                res.forEach(function (element, index) {
                    let taskobject = {};
                    taskobject['key'] = element["key"];
                    taskobject['id'] = 'Automata' + index;
                    rowsAutomata.push(taskobject);

                })
                setRowsAutomata(rowsAutomata);

            })
            .catch(err => {
            });
    }
    function getSteps() {
        const BasicInfoLabel = i18n.t('editScheduleRecommendation.basicInfo');
        const SetFrequencyLabel = i18n.t('editScheduleRecommendation.setFrequency');
        const AddTaskAutomata = i18n.t('editScheduleRecommendation.addTaskAutomata');
        const AddExec = i18n.t('editScheduleRecommendation.addExecutionParameters');
        const ViewRecommended = i18n.t('editScheduleRecommendation.viewRecommended');
        const ReviewSub = i18n.t('editScheduleRecommendation.reviewSubmit');
        return [BasicInfoLabel, SetFrequencyLabel, AddTaskAutomata, AddExec, ViewRecommended, ReviewSub];

    }

    function getStepContent(step) {
        switch (step) {
            case 0:
                return <BasicInfo
                    validateForm={validateForm}
                    valid_appstackname={valid_appstackname}
                    helptext_appstackname={helptext_appstackname}
                    handleScheduleChange={handleScheduleChange}
                    onRemoveAppstack={onRemoveAppstack}
                    handleDescriptionChange={handleDescriptionChange}
                    description={description}
                    schedule={schedule}
                    RowsFranchise={RowsFranchise}
                    RowsClient={RowsClient}
                    RowsTech={RowsTech}
                    handleChangeAppStack={handleChangeAppStack}
                    handleChangeApplicationServer={handleChangeApplicationServer}
                    handleTechnologyChange={handleTechnologyChange}
                    RowsApplicationServer={RowsApplicationServer}
                    RowsAppStack={RowsAppStack}
                    handleChangeClient={handleChangeClient}
                    handleChangefranchise={handleChangefranchise}
                    applicationServer={applicationServer}
                    appStack={appStack}
                    technology={technology}
                    franchise={franchise}
                    onSelectAppstack={onSelectAppstack}
                    setfranchise={setfranchise}
                    settechnology={settechnology}
                    client={client}
                    setclient={setclient}

                    helptext_apphostname={helptext_apphostname}
                    helptext_clientname={helptext_clientname}
                    valid_clientname={valid_clientname}
                    valid_franchisename={valid_franchisename}
                    valid_apphostname={valid_apphostname}
                    helptext_automata_frequency={helptext_automata_frequency}

                    helptextAutomataFrequency={helptextAutomataFrequency}
                    dropdownFlag1={dropdownFlag1}
                    radioweeklyFlag1={radioweeklyFlag1}
                    radioweeklyFlag2={radioweeklyFlag2}
                    calendarChecked={calendarChecked}
                    selectFlagCalendar={selectFlagCalendar}
                    selectFlag={selectFlag}
                    calendarcheckedvalueflag={calendarcheckedvalueflag}
                    dropdownWeeklyFlag={dropdownWeeklyFlag}
                    everyTextboxFlag={everyTextboxFlag}
                    dropdownFlag={dropdownFlag}
                    dropdownFlagCalendar={dropdownFlagCalendar}
                    valid_sdate={valid_sdate}
                    valid_edate={valid_edate}
                    valid_stime={valid_stime}
                    valid_etime={valid_etime}
                    noresult={noresult}
                    helptext_monthly={helptext_monthly}
                    helptext_freq={helptext_freq}
                    helptext_scheduledesc={helptext_scheduledesc}
                    helptext_auto={helptext_auto}
                    helptext_edate={helptext_edate}
                    helptext_sdate={helptext_sdate}
                    helptext_stime={helptext_stime}
                    helptext_etime={helptext_etime}

                    valid_freq_value={valid_freq_value}
                    valid_scheduledesc={valid_scheduledesc}
                    valid_auto={valid_auto}
                    helptext_dur={helptext_dur}
                    frequencytext={frequencytext}
                    helptext_schedulename={helptext_schedulename}
                    valid_schedulename={valid_schedulename}
                    helptext_franchisename={helptext_franchisename}
                    helptext_technology={helptext_technology}
                    valid_technology={valid_technology}
                />
            case 1:
                return <SetFrequency currentOccurance={currentOccurance}
                    handleCalendarNameChange={handleCalendarNameChange}
                    occurances={occurances}
                    handleChangeOccurance={handleChangeOccurance}
                    handleChangeFrequency={handleChangeFrequency}
                    currentFrequency={currentFrequency}
                    RowsAppStack={RowsAppStack}
                    frequency={frequency}
                    appStack={appStack}
                    setCurrentFrequency={setCurrentFrequency}
                    handleCheckedWeek={handleCheckedWeek}
                    checked={checked}
                    handletimeFilterSelectionsChange={handletimeFilterSelectionsChange}
                    handleScheduleMonthlyDay={handleScheduleMonthlyDay}
                    handleScheduleMonthlyDayName={handleScheduleMonthlyDayName}
                    handleRadioChange={handleRadioChange}
                    handleWeeklyRadioChange={handleWeeklyRadioChange}
                    calendarCheckedChange={calendarCheckedChange}
                    failFastChange={failFastChange}
                    timeFilterSelections={timeFilterSelections}
                    handleTimeChange={handleTimeChange}

                    helptextAutomataFrequency={helptextAutomataFrequency}
                    dropdownFlag1={dropdownFlag1}
                    radioweeklyFlag1={radioweeklyFlag1}
                    radioweeklyFlag2={radioweeklyFlag2}
                    calendarChecked={calendarChecked}
                    selectFlagCalendar={selectFlagCalendar}
                    selectFlag={selectFlag}
                    calendarcheckedvalueflag={calendarcheckedvalueflag}
                    dropdownWeeklyFlag={dropdownWeeklyFlag}
                    everyTextboxFlag={everyTextboxFlag}
                    dropdownFlag={dropdownFlag}
                    dropdownFlagCalendar={dropdownFlagCalendar}
                    valid_sdate={valid_sdate}
                    valid_edate={valid_edate}
                    valid_stime={valid_stime}
                    valid_etime={valid_etime}
                    noresult={noresult}
                    helptext_monthly={helptext_monthly}
                    helptext_freq={helptext_freq}
                    helptext_scheduledesc={helptext_scheduledesc}
                    helptext_auto={helptext_auto}
                    helptext_edate={helptext_edate}
                    helptext_sdate={helptext_sdate}
                    helptext_stime={helptext_stime}
                    helptext_etime={helptext_etime}
                    valid_freq_value={valid_freq_value}
                    valid_scheduledesc={valid_scheduledesc}
                    valid_edate={valid_edate}
                    valid_auto={valid_auto}
                    helptext_dur={helptext_dur}
                    frequencytext={frequencytext}

                    helptext_apphostname={helptext_apphostname}
                    helptext_clientname={helptext_clientname}
                    valid_clientname={valid_clientname}
                    valid_apphostname={valid_apphostname}
                    helptext_automata_frequency={helptext_automata_frequency}
                    between_start_time={between_start_time}
                    between_end_time={between_end_time}
                />
            case 2:
                return <AddTask handleTaskName={handleTaskName}
                    activeStep={activeStep}
                    validateForm={validateForm}
                    initialSelected={initialSelected}
                    createSelectItems={createSelectItems}
                    tasksArray={tasksArray}
                    RowsAppStack={RowsAppStack}
                    appStack={appStack}
                    handleTaskDescription={handleTaskDescription}
                    taskCompletion={taskCompletion}
                    handleChangeTaskException={handleChangeTaskException}
                    handleChangeTaskCompletion={handleChangeTaskCompletion}
                    currentTaskException={currentTaskException}
                    currentTaskCompletion={currentTaskCompletion}
                    handleChangeAutomata={handleChangeAutomata}
                    currentAutomata={currentAutomata}
                    frequency={frequency}
                    handleDelay={handleDelay}
                    delay={delay}
                    RowsAutomata={RowsAutomata}
                    renderNewTask={renderNewTask}
                    renderNewAutomata={renderNewAutomata}
                    numberOfAutomata={numberOfAutomata}
                    numberOfTasks={numberOfTasks}
                    handleCheckedFailFast={handleCheckedFailFast}
                    handleCheckedInitialTask={handleCheckedInitialTask}
                    checkedInitalTask={checkedInitalTask}
                    checkedFailFast={checkedFailFast}

                    helptextAutomataFrequency={helptextAutomataFrequency}
                    dropdownFlag1={dropdownFlag1}
                    radioweeklyFlag1={radioweeklyFlag1}
                    radioweeklyFlag2={radioweeklyFlag2}
                    calendarChecked={calendarChecked}
                    selectFlagCalendar={selectFlagCalendar}
                    selectFlag={selectFlag}
                    calendarcheckedvalueflag={calendarcheckedvalueflag}
                    dropdownWeeklyFlag={dropdownWeeklyFlag}
                    everyTextboxFlag={everyTextboxFlag}
                    dropdownFlag={dropdownFlag}
                    dropdownFlagCalendar={dropdownFlagCalendar}
                    valid_sdate={valid_sdate}
                    noresult={noresult}
                    helptext_monthly={helptext_monthly}
                    helptext_freq={helptext_freq}
                    helptext_scheduledesc={helptext_scheduledesc}
                    helptext_auto={helptext_auto}
                    helptext_edate={helptext_edate}
                    helptext_sdate={helptext_sdate}
                    valid_freq_value={valid_freq_value}
                    valid_scheduledesc={valid_scheduledesc}
                    valid_edate={valid_edate}
                    valid_auto={valid_auto}
                    helptext_dur={helptext_dur}
                    frequencytext={frequencytext}

                    helptext_apphostname={helptext_apphostname}
                    helptext_clientname={helptext_clientname}
                    valid_clientname={valid_clientname}
                    valid_apphostname={valid_apphostname}
                    helptext_automata_frequency={helptext_automata_frequency}
                />
            case 3:
                return <AddDuration time={time}
                    handleSubmit={handleRecommendedresource}
                    tasksArray={tasksArray}
                    appStack={appStack}
                    handleTime={handleTime}
                    RowsAppStack={RowsAppStack}
                    handleTimeDelay={handleTimeDelay}
                    timeDelay={timeDelay}
                    renderNewTask={renderNewTask}
                    numberOfTasks={numberOfTasks}
                    currentAutomata={currentAutomata}
                    renderNewAutomata={renderNewAutomata}
                    numberOfAutomata={numberOfAutomata}

                    helptextAutomataFrequency={helptextAutomataFrequency}
                    dropdownFlag1={dropdownFlag1}
                    radioweeklyFlag1={radioweeklyFlag1}
                    radioweeklyFlag2={radioweeklyFlag2}
                    calendarChecked={calendarChecked}
                    selectFlagCalendar={selectFlagCalendar}
                    selectFlag={selectFlag}
                    calendarcheckedvalueflag={calendarcheckedvalueflag}
                    dropdownWeeklyFlag={dropdownWeeklyFlag}
                    everyTextboxFlag={everyTextboxFlag}
                    dropdownFlag={dropdownFlag}
                    dropdownFlagCalendar={dropdownFlagCalendar}
                    valid_sdate={valid_sdate}
                    noresult={noresult}
                    helptext_monthly={helptext_monthly}
                    helptext_freq={helptext_freq}
                    helptext_scheduledesc={helptext_scheduledesc}
                    helptext_auto={helptext_auto}
                    helptext_edate={helptext_edate}
                    helptext_sdate={helptext_sdate}
                    valid_freq_value={valid_freq_value}
                    valid_scheduledesc={valid_scheduledesc}
                    valid_edate={valid_edate}
                    valid_auto={valid_auto}
                    helptext_dur={helptext_dur}
                    frequencytext={frequencytext}

                    helptext_apphostname={helptext_apphostname}
                    helptext_clientname={helptext_clientname}
                    valid_clientname={valid_clientname}
                    valid_apphostname={valid_apphostname}
                    helptext_automata_frequency={helptext_automata_frequency}
                />
            case 4:
                return <RecommendResource
                    ResourceNameChange={ResourceNameChange}
                    handleTaskName={handleTaskName}
                    initialSelected={initialSelected}
                    createSelectItems={createSelectItems}
                    tasksArray={tasksArray}
                    RowsAppStack={RowsAppStack}
                    appStack={appStack}
                    handleTaskDescription={handleTaskDescription}
                    taskCompletion={taskCompletion}
                    handleChangeTaskException={handleChangeTaskException}
                    handleChangeTaskCompletion={handleChangeTaskCompletion}
                    currentTaskException={currentTaskException}
                    currentTaskCompletion={currentTaskCompletion}
                    handleChangeAutomata={handleChangeAutomata}
                    currentAutomata={currentAutomata}
                    frequency={frequency}
                    handleDelay={handleDelay}
                    delay={delay}
                    RowsAutomata={RowsAutomata}
                    renderNewTask={renderNewTask}
                    renderNewAutomata={renderNewAutomata}
                    numberOfAutomata={numberOfAutomata}
                    numberOfTasks={numberOfTasks}
                    handleCheckedFailFast={handleCheckedFailFast}
                    handleCheckedInitialTask={handleCheckedInitialTask}
                    checkedInitalTask={checkedInitalTask}
                    checkedFailFast={checkedFailFast}
                    RowsAutomata={RowsAutomata}
                    currentAutomata={currentAutomata}
                    tasksArray={tasksArray}
                    numberOfTasks={numberOfTasks}
                    numberOfAutomata={numberOfAutomata}

                    helptextAutomataFrequency={helptextAutomataFrequency}
                    dropdownFlag1={dropdownFlag1}
                    radioweeklyFlag1={radioweeklyFlag1}
                    radioweeklyFlag2={radioweeklyFlag2}
                    calendarChecked={calendarChecked}
                    selectFlagCalendar={selectFlagCalendar}
                    selectFlag={selectFlag}
                    calendarcheckedvalueflag={calendarcheckedvalueflag}
                    dropdownWeeklyFlag={dropdownWeeklyFlag}
                    everyTextboxFlag={everyTextboxFlag}
                    dropdownFlag={dropdownFlag}
                    dropdownFlagCalendar={dropdownFlagCalendar}
                    valid_sdate={valid_sdate}
                    noresult={noresult}
                    helptext_monthly={helptext_monthly}
                    helptext_freq={helptext_freq}
                    helptext_scheduledesc={helptext_scheduledesc}
                    helptext_auto={helptext_auto}
                    helptext_edate={helptext_edate}
                    helptext_sdate={helptext_sdate}
                    valid_freq_value={valid_freq_value}
                    valid_scheduledesc={valid_scheduledesc}
                    valid_edate={valid_edate}
                    valid_auto={valid_auto}
                    helptext_dur={helptext_dur}
                    frequencytext={frequencytext}

                    helptext_apphostname={helptext_apphostname}
                    helptext_clientname={helptext_clientname}
                    valid_clientname={valid_clientname}
                    valid_apphostname={valid_apphostname}
                    helptext_automata_frequency={helptext_automata_frequency}
                />
            case 5:
                return <ReviewSubmit handleScheduleChange={handleScheduleChange}
                    activeStep={activeStep}
                    validateForm={validateForm}
                    currentOccurance={currentOccurance}
                    automataExecutionTime={automataExecutionTime}
                    onboardAutomata={onboardAutomata}
                    consolidatedTime={consolidatedTime}
                    endTimeFormat={endTimeFormat}
                    frequencyWeek={frequencyWeek}
                    frequencyWeekDay={frequencyWeekDay}
                    calendarName={calendarName}
                    frequencyValue={frequencyValue}
                    calendarNameOptions={calendarNameOptions}
                    frequencyValue={frequencyValue}
                    handleDescriptionChange={handleDescriptionChange}
                    description={description}
                    appStack={appStack}
                    schedule={schedule}
                    RowsAppStack={RowsAppStack}
                    timeFilterSelections={timeFilterSelections}
                    handleTimeChange={handleTimeChange}
                    RowsFranchise={RowsFranchise}
                    RowsClient={RowsClient}
                    RowsTech={RowsTech}
                    handleChangeApplicationServer={handleChangeApplicationServer}
                    handleTechnologyChange={handleTechnologyChange}
                    RowsApplicationServer={RowsApplicationServer}
                    handleChangeClient={handleChangeClient}
                    handleChangefranchise={handleChangefranchise}
                    applicationServer={applicationServer}
                    technology={technology}
                    franchise={franchise}
                    setfranchise={setfranchise}
                    client={client}
                    setclient={setclient}
                    occurances={occurances}
                    handleChangeOccurance={handleChangeOccurance}
                    handleChangeFrequency={handleChangeFrequency}
                    currentFrequency={currentFrequency}
                    frequency={frequency}
                    setCurrentFrequency={setCurrentFrequency}
                    handleCheckedWeek={handleCheckedWeek}
                    checked={checked}
                    handleTaskName={handleTaskName}
                    // taskName={taskName}
                    tasksArray={tasksArray}
                    handleTaskDescription={handleTaskDescription}
                    taskCompletion={taskCompletion}
                    handleChangeTaskException={handleChangeTaskException}
                    handleChangeTaskCompletion={handleChangeTaskCompletion}
                    currentTaskException={currentTaskException}
                    currentTaskCompletion={currentTaskCompletion}
                    handleChangeAutomata={handleChangeAutomata}
                    currentAutomata={currentAutomata}
                    frequency={frequency}
                    handleDelay={handleDelay}
                    delay={delay}
                    RowsAutomata={RowsAutomata}
                    renderNewTask={renderNewTask}
                    renderNewAutomata={renderNewAutomata}
                    numberOfAutomata={numberOfAutomata}
                    numberOfTasks={numberOfTasks}
                    handleCheckedFailFast={handleCheckedFailFast}
                    handleCheckedInitialTask={handleCheckedInitialTask}
                    checkedInitalTask={checkedInitalTask}
                    checkedFailFast={checkedFailFast}
                    time={time}
                    handleTime={handleTime}
                    handleTimeDelay={handleTimeDelay}
                    timeDelay={timeDelay}
                    renderNewTask={renderNewTask}
                    numberOfTasks={numberOfTasks}
                    currentAutomata={currentAutomata}
                    renderNewAutomata={renderNewAutomata}
                    numberOfAutomata={numberOfAutomata}
                    RowsAutomata={RowsAutomata} currentAutomata={currentAutomata} numberOfAutomata={numberOfAutomata}


                    helptextAutomataFrequency={helptextAutomataFrequency}
                    dropdownFlag1={dropdownFlag1}
                    radioweeklyFlag1={radioweeklyFlag1}
                    radioweeklyFlag2={radioweeklyFlag2}
                    calendarChecked={calendarChecked}
                    selectFlagCalendar={selectFlagCalendar}
                    selectFlag={selectFlag}
                    calendarcheckedvalueflag={calendarcheckedvalueflag}
                    dropdownWeeklyFlag={dropdownWeeklyFlag}
                    everyTextboxFlag={everyTextboxFlag}
                    dropdownFlag={dropdownFlag}
                    dropdownFlagCalendar={dropdownFlagCalendar}
                    valid_sdate={valid_sdate}
                    noresult={noresult}
                    helptext_monthly={helptext_monthly}
                    helptext_freq={helptext_freq}
                    helptext_scheduledesc={helptext_scheduledesc}
                    helptext_auto={helptext_auto}
                    helptext_edate={helptext_edate}
                    helptext_sdate={helptext_sdate}
                    valid_freq_value={valid_freq_value}
                    valid_scheduledesc={valid_scheduledesc}
                    valid_edate={valid_edate}
                    valid_auto={valid_auto}
                    helptext_dur={helptext_dur}
                    frequencytext={frequencytext}

                    helptext_apphostname={helptext_apphostname}
                    helptext_clientname={helptext_clientname}
                    valid_clientname={valid_clientname}
                    valid_apphostname={valid_apphostname}
                    helptext_automata_frequency={helptext_automata_frequency}
                    helptext_technology={helptext_technology}
                    valid_technology={valid_technology}
                />
            default:
                return '';
        }
    }

    function handleCheckedWeek(e, day) {
        // setChecked(!checked);
        // const isChecked = e.target.checked;
        setChecked(e);
        validateForm();

    }

    function initialSelected() {

    }

    async function getAppstackforApps(inp) {
        //console.log(JSON.stringify(inp));
        let appstackname;
        let res = await callPostApi(Constants.POSTAPPSTACKFORAPPS, { 'Content-Type': 'application/json' },
            JSON.stringify(inp))
        // setRowsApplicationStack(rowsApplicationStack);    
        if (res.status === 401) {
            //console.log('handle click' + localStorage.getItem('token'));
            localStorage.removeItem('token');
            localStorage.removeItem('expires_in');
            localStorage.removeItem('username');
            localStorage.removeItem('refresh_token');
            alert('Token Expired');
            window.location.href = '/homepage';
        } else if (res.status === 400) {
            sethelptext_appstackname("No App Stack available for the selected apps");
            setvalidappstackname(true);
        } else {
            //console.log('here in client side app else block-start');
            // let respData = res.json();
            let respData = res;
            if (respData.length <= 0) {
                alert("No App Stack available for the selected Apps");
                sethelptext_appstackname("No App Stack available for the selected apps");
                setvalidappstackname(true);
                appstackname = respData.map(appstack => { return { value: appstack.appstack_nm }; });
            } else {
                appstackname = respData.map(appstack => { return { value: appstack.appstack_nm }; });
            }
        }
        return appstackname;
    }

    async function onSelectAppstack(selectedList, selectedItem) {
        //console.log(selectedList);
        //console.log(selectedItem);
        const value = [];
        let appstackvalue = [];
        let uniqueappstackvalue = [];
        if (selectedList.length > 0) {
            for (let i = 0; i < selectedList.length; i++) {
                value.push(selectedList[i].appstack_id);
            }
            appstackvalue = await getAppstackforApps(value);
        }
        //console.log(appstackvalue);
        appstackvalue.map(v => {
            uniqueappstackvalue.push(v.value);
        })

        // const uniqueappstackvalue = [...new Set(appstackvalue.value)];
        setAppStack(uniqueappstackvalue)
        sethelptext_appstackname("");
        setvalidappstackname(false)
    }
    async function onRemoveAppstack(selectedList, removedItem) {
        //console.log(selectedList);
        //console.log(removedItem);
        const value = [];
        let appstackvalue = [];
        let uniqueappstackvalue = [];
        if (selectedList.length > 0) {
            for (let i = 0; i < selectedList.length; i++) {
                value.push(selectedList[i].appstack_id);
            }
            appstackvalue = await getAppstackforApps(value);
        }
        //console.log(appstackvalue);
        appstackvalue.map(v => {
            uniqueappstackvalue.push(v.value);
        })
        //console.log(uniqueappstackvalue);
        setAppStack(uniqueappstackvalue)
        sethelptext_appstackname("");
        setvalidappstackname(false)
    }

    function validateForm(e) {

        if (
            activeStep === 0 &&
            schedule &&
            description &&
            franchise &&
            applicationServer &&
            technology
        ) {
            //console.log("Inside validateForm...");
            setselectedSubmit(false)

        }

        else if (activeStep === 1 && timeFilterSelections.startDate !== "undefined" &&
            timeFilterSelections.endDate != "undefined" &&
            timeFilterSelections.startTime != "undefined" &&
            timeFilterSelections.endTime != "undefined" &&
            automataFrequency) {
            //console.log("Inside validateForm...");
            setselectedSubmit(false)
        }
        else {
            //console.log("Inside validateForm...");

        }



        let valid_sdate = false;
        let valid_edate = false;
        let valid_stime = false;
        let valid_etime = false;
        let valid_auto = false;
        let valid_scheduledesc = false;
        let valid_schedulename = false;

        let valid_freq_value = false;
        let helptext_sdate = "";
        let helptext_edate = "";
        let helptext_stime = "";
        let helptext_etime = "";
        let helptext_auto = "";
        let helptext_scheduledesc = "";
        let helptext_schedulename = "";
        let helptext_dur = "";
        let helptext_freq = "";
        let helptext_success = "";
        let helptext_fail = "";
        let helptext_automataduration = "";
        let helptext_resourcename = "";
        let helptext_monthly = "";
        let valid_monthly = false;
        let valid_startUpParamName = false;
        let valid_startUpParamValue = false;
        let helptext_startUpParamName = "";
        let helptext_startUpParamValue = "";
        let helptext_automata_frequency = "";
        let helptext_apphostname = "";
        let valid_apphostname = false;
        let valid_franchisename = false;
        let valid_technology = false;
        let helptext_franchisename = "";
        let helptext_technology = "";

        let formIsValid = true;
        let formOneIsValid = true;
        /* task page*/

        if (activeStep === 0) {
            if (description === "") {
                valid_scheduledesc = true;
                helptext_scheduledesc = i18n.t('scheduleRecommendation.scheduleDescriptionError');
                formOneIsValid = false;
            }

            if (schedule === "") {
                valid_schedulename = true;
                helptext_schedulename = i18n.t('editScheduleRecommendation.helptextScheduleName');
                formOneIsValid = false;
            }

            if (applicationServer === "") {
                valid_apphostname = true;
                helptext_apphostname = i18n.t('scheduleRecommendation.applicationhostnameError');
                formOneIsValid = false;
            }
            if (franchise === "") {
                valid_franchisename = true;
                helptext_franchisename = i18n.t('editScheduleRecommendation.helptextFranchiseName');
                formOneIsValid = false;
            }
            if (technology === "") {
                valid_technology = true;
                helptext_technology = i18n.t('editScheduleRecommendation.helptextTechnologyName');
                formOneIsValid = false;
            }
        }
        else if (activeStep === 1) {
            if (timeFilterSelections.startDate == "" || timeFilterSelections.startDate == undefined) {
                helptext_sdate = i18n.t('scheduleRecommendation.helptext_sdate');
                valid_sdate = true;
                formOneIsValid = false;
            }
            if (timeFilterSelections.endDate == "" || timeFilterSelections.endDate == undefined) {
                helptext_edate = i18n.t('scheduleRecommendation.helptext_edate');
                valid_edate = true;
                formOneIsValid = false;
            }
            if (timeFilterSelections.startTime == "" || timeFilterSelections.startTime == undefined) {
                helptext_stime = i18n.t('editScheduleRecommendation.helptextStartTime');
                formOneIsValid = false;
            }
            if (timeFilterSelections.endTime == "" || timeFilterSelections.endTime == undefined) {
                helptext_etime = i18n.t('editScheduleRecommendation.helptextEndTime');
                valid_etime = true;
                formOneIsValid = false;
            }

            var date1 = moment(timeFilterSelections.startTime),
                date2 = moment(timeFilterSelections.endTime);
            var duration = moment.duration(date2.diff(date1));

            duration = duration.asMinutes();
            for (var i = 0; i < tasksArray.length; i++) {
                for (var j = 0; j < tasksArray[i].automataArray.length; j++) {
                    if (tasksArray[i].automataArray[j].timeDelay !== "" && !isNaN(duration) &&
                        duration > 0 && duration < tasksArray[i].automataArray[j].timeDelay) {
                        tasksArray[i].automataArray[j].valid_dur = true;
                        tasksArray[i].automataArray[j].helptext_dur = i18n.t('scheduleRecommendation.helptestDurationDiff');
                        formOneIsValid = false;
                    }
                }
            }
            //assuming duration=== timeDelay
            if (automataFrequency === "weekly" && timeDelay < 10080) {
                valid_sdate = true;
                valid_edate = true;
                formOneIsValid = false;
                helptext_sdate = i18n.t('scheduleRecommendation.weeklymessagestartLable');
                helptext_edate = i18n.t('scheduleRecommendation.weeklymessagestartLable');
            }


            if (new Date(timeFilterSelections.startTime).getTime() > new Date(timeFilterSelections.endTime).getTime()) {
                valid_edate = true;
                helptext_edate = i18n.t('scheduleRecommendation.weeklymessageerrorLable')
                formOneIsValid = false;
            }

            if (timeFilterSelections.startTime === "Invalid Date" ||
                (new Date(timeFilterSelections.startTime).getTime() < new Date().getTime())) {
                valid_sdate = true;
                formOneIsValid = false;
                if (timeFilterSelections.startTime === "Invalid Date") {
                    helptext_sdate = i18n.t('scheduleRecommendation.dateLable2')
                } else {
                    helptext_sdate = i18n.t('scheduleRecommendation.dateLable3')
                }
            }

            if (timeFilterSelections.endTime === "Invalid Date" ||
                (new Date(timeFilterSelections.endTime).getTime() < new Date().getTime())) {

                valid_edate = true;
                formOneIsValid = false;
                if (timeFilterSelections.endTime == "Invalid Date") {
                    helptext_edate = i18n.t('scheduleRecommendation.dateLable2')
                } else {
                    helptext_edate = i18n.t('scheduleRecommendation.dateLable3')
                }
            }
            if (automataFrequency == "daily") {


                if (duration >= 0 && duration < 1440) {
                    helptext_edate = i18n.t('scheduleRecommendation.durationError1')

                    valid_edate = true;
                    formOneIsValid = false;

                }
            } else if (automataFrequency === "hourly") {


                if (duration >= 0 && duration < 60) {
                    helptext_edate = i18n.t('scheduleRecommendation.durationError2')
                    valid_edate = true;
                    formOneIsValid = false;

                }
            } else if (automataFrequency == "minutely") {

                if (duration >= 0 && duration < 1) {
                    helptext_edate = i18n.t('scheduleRecommendation.durationError3')
                    valid_edate = true;
                    formOneIsValid = false;
                }

            }
            if (automataFrequency === "weekly") {
                if (radiobuttonvalueweekly === "") {
                    helptext_automata_frequency = i18n.t('scheduleRecommendation.optionselectionError');
                    formOneIsValid = false;
                }
            } else if (automataFrequency === "monthly") {
                if (radiobuttonvalue === "") {
                    helptext_automata_frequency = i18n.t('scheduleRecommendation.optionselectionError');;
                    formOneIsValid = false;
                }
            }


            // if (this.state.automata_name !== "") {
            //   axios.get("/page2/automataname", {
            //     headers: {
            //       Authorization: "Bearer " + localStorage.getItem("token")
            //     },
            //     params: {
            //       automata_name: this.state.automata_name
            //     }
            //   }, {
            //     onUploadProgress: ProgressEvent => {
            //       this.setState({
            //         upload_state: true,
            //         loaded: (ProgressEvent.loaded / ProgressEvent.total) * 100
            //       });
            //     }
            //   }
            //   )
            //     .then(res => {
            //       // console.log(res);
            //       console.log(JSON.stringify(res.status));
            //       if (res.status === 200) {
            //         // console.log("Hi1");
            //         console.log(res);
            //         if (!res.data) {
            //           formIsValid = true;
            //           valid_auto = false;
            //         } else {
            //           valid_auto = true;
            //           helptext_auto =  i18n.t('scheduleRecommendation.schedulenameexistError');
            //           formIsValid = false;
            //         }
            //       }
            //     }).catch(err => {
            //       console.log(err);
            //     });

            // }

            // if (this.state.automata_name === "") { //TBD
            //     valid_auto = true;
            //     helptext_auto = i18n.t('scheduleRecommendation.scheduleNameError');
            //     formIsValid = false;
            // }


            for (var i = 0; i < tasksArray.length; i++) {
                for (var j = 0; j < tasksArray[i].automataArray.length; j++) {
                    if (tasksArray[i].automataArray[j].timeDelay === "") {
                        tasksArray[i].automataArray[j].valid_dur = true;
                        tasksArray[i].automataArray[j].helptext_dur = i18n.t('scheduleRecommendation.scheduleDurationError');
                        formOneIsValid = false;
                    }
                }
            }

            if (frequencyValue === 0) {
                valid_freq_value = true;
                helptext_freq = i18n.t('scheduleRecommendation.enterzeroError');
                formOneIsValid = false;
            }

        }

        else if (activeStep === 2) {
            for (var i = 0; i < tasksArray.length; i++) {
                if (tasksArray[i].taskDescription === "") {
                    tasksArray[i].valid_taskDescription = true;
                    tasksArray[i].helptext_taskdesc = i18n.t('scheduleRecommendation.taskdescError');
                    formOneIsValid = false;
                }
            }

            for (var i = 0; i < tasksArray.length; i++) {
                if (tasksArray[i].taskCompletion === "") {
                    tasksArray[i].valid_successScenario = true;
                    tasksArray[i].helptext_success = i18n.t('scheduleRecommendation.successError');
                    formOneIsValid = false;
                }
            }
            for (var i = 0; i < tasksArray.length; i++) {
                if (tasksArray[i].taskException === "") {
                    tasksArray[i].valid_failureScenario = true;
                    tasksArray[i].helptext_fail = i18n.t('scheduleRecommendation.failureError');
                    formOneIsValid = false;
                }
            }

            for (var i = 0; i < tasksArray.length; i++) {
                for (var j = 0; j < tasksArray[i].automataArray.length; j++) {
                    if (tasksArray[i].taskName === "") {
                        tasksArray[i].valid_taskName = true;
                        tasksArray[i].helptext_taskname = i18n.t('scheduleRecommendation.taskenameError');
                        formOneIsValid = false;
                    }
                }
            }

            for (var i = 0; i < tasksArray.length; i++) {
                for (var j = 0; j < tasksArray[i].automataArray.length; j++) {
                    if (tasksArray[i].automataArray[j].automataName === "") {
                        tasksArray[i].automataArray[j].valid_automataName = true;
                        tasksArray[i].automataArray[j].helptext_automataname = i18n.t('scheduleRecommendation.automatanameError');
                        formOneIsValid = false;
                    }
                }
            }



        }



        //     else if (activeStep === 4){
        //     for (var i = 0; i < tasksArray.length; i++) {
        //         for (var j = 0; j <tasksArray[i].automataArray.length; j++) {
        //         if (tasksArray[i].taskName === "") {
        //             tasksArray[i].valid_taskName = true;
        //             tasksArray[i].helptext_taskname = i18n.t('scheduleRecommendation.taskenameError');
        //             formOneIsValid = false;
        //         } else {
        //             for (var j = 0; j < i; j++) {
        //                 if (tasksArray[i].taskName === tasksArray[j].taskName) {
        //                     tasksArray[i].valid_taskName = true;
        //                     tasksArray[i].helptext_taskname = i18n.t('scheduleRecommendation.taskduplicateError');
        //                     formOneIsValid = false;
        //                 }
        //             }
        //         }
        //     }

        //     }
        //     for (var i = 0; i < tasksArray.length; i++) {
        //         if (tasksArray[i].taskDescription === "") {
        //             tasksArray[i].valid_taskDescription = true;
        //             tasksArray[i].helptext_taskdesc = i18n.t('scheduleRecommendation.taskdescError');
        //             formOneIsValid = false;
        //         }
        //     }
        //     for (var i = 0; i < tasksArray.length; i++) {
        //         if (tasksArray[i].taskCompletion === "") {
        //             tasksArray[i].valid_successScenario = true;
        //             tasksArray[i].helptext_success = i18n.t('scheduleRecommendation.successError');
        //             formOneIsValid = false;
        //         }
        //     }
        //     for (var i = 0; i < tasksArray.length; i++) {
        //         if (tasksArray[i].taskException === "") {
        //             tasksArray[i].valid_failureScenario = true;
        //             tasksArray[i].helptext_fail = i18n.t('scheduleRecommendation.failureError');
        //             formOneIsValid = false;
        //         }
        //     }
        //     for (var i = 0; i < tasksArray.length; i++) {
        //         for (var j = 0; j < tasksArray[i].automataArray.length; j++) {
        //             if (tasksArray[i].automataArray[j].automataName === "") {
        //                 tasksArray[i].automataArray[j].valid_automataName = true;
        //                 tasksArray[i].automataArray[j].helptext_automataname = i18n.t('scheduleRecommendation.automatanameError');
        //                 formOneIsValid = false;
        //             }
        //         }
        //     }
        // }

        // else if (activeStep === 4){

        //     if (!(recommendResourceCheck)) {
        //         for (var i = 0; i < tasksArray.length; i++) {
        //             for (var j = 0; j < tasksArray[i].automataArray.length; j++) {
        //                 if (tasksArray[i].automataArray[j].resourceName === "") {
        //                     tasksArray[i].automataArray[j].valid_resourceName = true;
        //                     tasksArray[i].automataArray[j].helptext_resourcename = i18n.t('scheduleRecommendation.resourcenameError');
        //                     formOneIsValid = false;
        //                 }
        //             }
        //         }
        //     }
        // }
        setvalid_edate(valid_edate);
        setvalid_sdate(valid_sdate);
        setvalid_stime(valid_stime);
        setvalid_etime(valid_etime);
        setvalid_auto(valid_auto);
        setvalid_scheduledesc(valid_scheduledesc)
        setvalid_schedulename(valid_schedulename)
        setvalid_freq_value(valid_freq_value);
        sethelptext_sdate(helptext_sdate);
        sethelptext_edate(helptext_edate);
        sethelptext_etime(helptext_etime);
        sethelptext_stime(helptext_stime);
        sethelptext_auto(helptext_auto);
        sethelptext_scheduledesc(helptext_scheduledesc);
        sethelptext_schedulename(helptext_schedulename)
        sethelptext_dur(helptext_dur);
        sethelptext_freq(helptext_freq)
        setFlag(flag);
        setnoresult(false);
        setTasksArray(tasksArray)
        // setTasksArray(helptext_success)
        // setTasksArray(helptext_fail);
        // setTasksArray(helptext_automataduration);
        // setTasksArray(helptext_resourcename);
        // setTasksArray(valid_monthly);
        // sethelptext_monthly(helptext_monthly);
        /* TBD
        // setTasksArray(valid_startUpParamName);
        // setTasksArray(valid_startUpParamValue);
        // setTasksArray(helptext_startUpParamName);
        // setTasksArray(helptext_startUpParamValue);
        */
        sethelptext_automata_frequency(helptext_automata_frequency);
        sethelptext_apphostname(helptext_apphostname);
        sethelptext_clientname(helptext_clientname);
        sethelptext_franchisename(helptext_franchisename);
        sethelptext_technology(helptext_technology);
        setvalid_clientname(valid_clientname);
        setvalid_apphostname(valid_apphostname);
        setvalid_franchisename(valid_franchisename);
        setvalid_technology(valid_technology);

        return formOneIsValid;
    }



    function handleScheduleChange(e) {
        setSchedule(e.target.value);
        validateForm();

    }
    function handleTaskName(e, index) {
        let tasksArrayClone = [...tasksArray];
        // var taskid = e.target.id
        tasksArrayClone[index].taskName = e.target.value
        setTasksArray(tasksArrayClone);
        // validateForm();

    }
    function handleTaskDescription(e, index) {
        let tasksArrayClone = [...tasksArray];
        // var taskid = e.target.id
        tasksArrayClone[index].taskDescription = e.target.value
        setTasksArray(tasksArrayClone);
        //validateForm();

    }
    function handleTime(e, taskIndex, automataIndex) {
        let taskArrayClone = [...tasksArray];
        // let automataArrayClone = [...tasksArray;

        // var taskid = e.target.id
        taskArrayClone[taskIndex].automataArray[automataIndex].timeDelay = e.target.value
        setTasksArray(taskArrayClone);
        // validateForm();

        // setTimeDelay(e.target.value)
    }
    function handleChangeTaskException(selectedItem, index) {
        let tasksArrayClone = [...tasksArray];
        // var taskid = e.target.id
        tasksArrayClone[index].taskException = selectedItem
        setTasksArray(tasksArrayClone);
        // validateForm();

        // setcurrentTaskException(selectedItem)
    }
    function createSelectItems(e, taskindex, id) {
        let arrsize = numberOfTasks;
        let temparr = [];
        if (numberOfTasks === 1 && id === 'taskCompletion') {
            temparr.push(<option key='Stop' value='Stop'>'Stop'</option>)
        }
        else if (numberOfTasks === 1 && id === 'taskException') {
            temparr.push(<option key='Abort' value='Abort'>'Abort'</option>)
        }
        else {
            for (let i = 1; i <= arrsize; i++) {
                if (i - 1 == taskindex - 1) {
                    continue;
                } else {
                    temparr.push(<option key={i} value={i}>'Task' :: {i}</option>)
                }

                //here I will be creating my options dynamically based on
                //what props are currently passed to the parent component
            }
            if (id === 'taskCompletion') {
                temparr.push(<option key='Stop' value='Stop'>'Stop'</option>)
            }
            else if (id === 'taskException') {
                temparr.push(<option key='Abort' value='Abort'>'Abort'</option>)
            }

        }
        setTaskCompletion(temparr)
    }
    function handleChangeTaskCompletion(selectedItem, index) {
        let tasksArrayClone = [...tasksArray];
        // var taskid = e.target.id
        tasksArrayClone[index].taskCompletion = selectedItem
        setTasksArray(tasksArrayClone);
        // validateForm();
    }

    function addAutomata(index) {
        let automataID = 0;
        automataID = automataID + 1;
        const copyAutomataArray = Object.assign([], tasksArray[index].automataArray);
        // copyAutomataArray.splice(index, 0, {automataAddid: this.automataID});
        copyAutomataArray.push({ automataAddid: automataID, automataName: "", execution_time: 0, automataThreadCount: 1, resourceName: "", resourceDropdown: [], startUpParamArray: [{ startUpParamName: "", startUpParamValue: "", }] });
        let tasksArrayClone = [...tasksArray];
        tasksArrayClone[index].automataArray = copyAutomataArray;
        setTasksArray({ tasksArrayClone })
    }

    function handleChangeAutomata(selectedItems, index) {
        addAutomata(index);
        let tasksArrayClone = [...tasksArray];
        // // var taskid = e.target.id
        tasksArrayClone[index].automataArray = selectedItems
        // setTasksArray(tasksArrayClone);

        setCurrentAutomata(selectedItems)
        // let automCount = numberOfAutomata;
        // automCount = automCount + 1;
        // copyAutomArray.push({ taskAddid: automCount, time: "", timeDelay: ""});
        setTasksArray(tasksArrayClone)
        // setNumberOfTasks(copyTaskArray.length)
        // setCurrentAutomata(copyAutomArray)
        setNumberOfAutomata(tasksArrayClone[index].automataArray.length);
        // validateForm();


    }


    function handleDescriptionChange(e) {
        if (e.type === "change" || e.type === "mouseout")
            setDescription(e.target.value)
        validateForm();

    }
    function handleDelay(e, index) {
        let tasksArrayClone = [...tasksArray];
        // var taskid = e.target.id
        tasksArrayClone[index].postCompletionDelay = e.target.value
        setTasksArray(tasksArrayClone);
        // validateForm();

        // setDelay(e.target.value)
    }
    function handleTimeDelay(e, taskIndex, automataIndex) {
        let taskArrayClone = [...tasksArray];
        // let automataArrayClone = [...tasksArray;

        // var taskid = e.target.id
        taskArrayClone[taskIndex].automataArray[automataIndex].time = e.target.value
        setTasksArray(taskArrayClone);
        // validateForm();

        // setTimeDelay(e.target.value)
    }



    const handleChangefranchise = (selectedItem, e) => {
        let franchise = selectedItem;
        setfranchise(selectedItem, e);
        getAutomataRecords(franchise, client);
        validateForm();
    }
    const handleChangeClient = (selectedItem) => {
        let client = selectedItem;
        setclient(selectedItem)
        getAutomataRecords(client, franchise);

        // validateForm();
    }

    const handleChangeOccurance = (selectedItem) => {
        setCurrentOccurances(selectedItem)
        validateForm();

    }

    // const handleChangeFrequency = (selectedItem) => {
    //     setCurrentFrequency(selectedItem)
    //     validateForm();

    // }

    function handleChangeFrequency(selectedItem) {
        setAutomataFrequency(selectedItem);
        setCalendarChecked(false);
        setCalendarcheckedvalueflag(true);
        setHelptextAutomataFrequency("");
        setEveryTextboxFlag(false);
        // this.setState({ automata_frequency: e.target.value, calendarChecked: false, calendarcheckedvalueflag: true, helptext_automata_frequency: "", everyTextboxFlag: false });
        if (selectedItem === "Once") {
            setEveryTextboxFlag(true);
            setFrequencytext("");
            //   this.setState({ everyTextboxFlag: true, frequencytext: "" });
        } else if (selectedItem === "Minutely") {
            setFrequencytext(i18n.t('scheduleRecommendation.minute(s)'));
            // this.setState({ frequencytext: i18n.t('scheduleRecommendation.minute(s)') });
        } else if (selectedItem === "Hourly") {
            setFrequencytext(i18n.t('scheduleRecommendation.hour(s)'));
            // this.setState({ frequencytext: i18n.t('scheduleRecommendation.hour(s)') });
        } else if (selectedItem === "Daily") {
            setFrequencytext(i18n.t('scheduleRecommendation.day(s)'));
            // this.setState({ frequencytext: i18n.t('scheduleRecommendation.day(s)') });
        } else if (selectedItem === "Weekly") {
            setFrequencytext(i18n.t('scheduleRecommendation.week(s)'));
            // this.setState({ frequencytext: i18n.t('scheduleRecommendation.week(s)') });
        } else if (selectedItem === "Monthly") {
            setFrequencytext(i18n.t('scheduleRecommendation.month(s)'));
            // this.setState({ frequencytext: i18n.t('scheduleRecommendation.month(s)') });
        } else if (selectedItem === "Yearly") {
            setFrequencytext(i18n.t('scheduleRecommendation.year(s)'));
            // this.setState({ frequencytext: i18n.t('scheduleRecommendation.year(s)') });
        }
    }

    function handleChangeApplicationServer(selectedItem) {
        setApplicationServer(selectedItem)
        validateForm();

    }

    function handleChangeAppStack(selectedItem) {
        setAppStack(selectedItem)
        validateForm();
    }

    function handleTechnologyChange(selectedItem) {
        settechnology(selectedItem)
        validateForm();

    }

    function handleTimeChange(element, e) {
        var filterMoment = null;
        switch (element) {
            case 'startDate':
                filterMoment = moment(e[0]);
                var startDateTimeMoment = moment(filterMoment.format('l') + " " + timeFilterSelections.startTime + " " + timeFilterSelections.startAMPM);
                setTimeFilterSelections({
                    ...timeFilterSelections, "startDate": filterMoment.format('l'), "startDateTime": startDateTimeMoment.format(), "timeRangeType": "absolute"

                });
                break;
            case 'endDate':
                filterMoment = moment(e[0]);
                var endDateTimeMoment = moment(filterMoment.format('l') + " " + timeFilterSelections.endTime + " " + timeFilterSelections.endAMPM);
                setTimeFilterSelections({
                    ...timeFilterSelections, "endDate": filterMoment.format('l'), "endDateTime": endDateTimeMoment.format(), "timeRangeType": "absolute"
                });
                break;
            case 'startTime':
                var startDateTimeMoment = moment(timeFilterSelections.startDate + " " + e.target.value + " " + timeFilterSelections.startAMPM);
                setTimeFilterSelections({
                    ...timeFilterSelections, "startTime": e.target.value, "startDateTime": startDateTimeMoment.format(), "timeRangeType": "absolute"
                });
                break;
            case 'endTime':
                var endDateTimeMoment = moment(timeFilterSelections.endDate + " " + e.target.value + " " + timeFilterSelections.endAMPM);
                setTimeFilterSelections({
                    ...timeFilterSelections, "endTime": e.target.value, "endDateTime": endDateTimeMoment.format(), "timeRangeType": "absolute"
                });
                break;
            case 'startAMPM':
                var startDateTimeMoment = moment(timeFilterSelections.startDate + " " + timeFilterSelections.startTime + " " + e.target.value);
                setTimeFilterSelections({
                    ...timeFilterSelections, "startAMPM": e.target.value, "startDateTime": startDateTimeMoment.format(), "timeRangeType": "absolute"
                });
                break;

            case 'endAMPM':
                var endDateTimeMoment = moment(timeFilterSelections.endDate + " " + timeFilterSelections.endTime + " " + e.target.value);
                setTimeFilterSelections({
                    ...timeFilterSelections, "endAMPM": e.target.value, "endDateTime": endDateTimeMoment.format(), "timeRangeType": "absolute"
                });
                break;
            default:
        }
        validateForm();

    }

    function handletimeFilterSelectionsChange(e) {
        setTimeFilterSelections(e.target.value)
        validateForm();

    }
    function handleScheduleMonthlyDay(e) {
        setFrequencyWeek(e.target.value);
    }
    function handleScheduleMonthlyDayName(e) {
        setFrequencyWeekDay(e.target.value);
    }
    function handleRadioChange(e) {
        setRadiobuttonvalue(e.target.value);
        setFrequencyWeek("");
        setHelptextAutomataFrequency("");
        // this.setState({ radiobuttonvalue: e.target.value, frequency_week: "", helptext_automata_frequency: "", });
        if (e.target.value === 'radiovalue2') {
            setDropdownFlag(true);
            setDropdownFlagCalendar(false);
            setDropdownFlag1(false);
            setSelectFlag(false);
            setSelectFlagCalendar(true);
            //   this.setState({ dropdownFlag: true, dropdownFlagCalendar: false, dropdownFlag1: false, selectFlag: false, selectFlagCalendar: true });
        } else if (e.target.value === 'radiovalue3') {
            setDropdownFlag(false);
            setDropdownFlagCalendar(true);
            setDropdownFlag1(false);
            setSelectFlag(true);
            setSelectFlagCalendar(false);
            //   this.setState({ dropdownFlagCalendar: true, dropdownFlag: false, dropdownFlag1: false, selectFlag: true, selectFlagCalendar: false });
        } else if (e.target.value === 'radiovalue1') {
            setDropdownFlag(false);
            setDropdownFlagCalendar(false);
            setDropdownFlag1(false);
            setSelectFlag(true);
            setSelectFlagCalendar(false);
            //   this.setState({ dropdownFlagCalendar: false, dropdownFlag: false, dropdownFlag1: true, selectFlag: true, selectFlagCalendar: true });
        }
    }
    function handleWeeklyRadioChange(e) {
        setRadiobuttonvalue(e.target.value);
        setFrequencyWeek("");
        // this.setState({ radiobuttonvalueweekly: e.target.value, frequency_week: "", helptext_automata_frequency: "", });
        if (e.target.value === 'radiovalueweekly1') {
            setDropdownWeeklyFlag(true);
            setRadioweeklyFlag1(true);
            setRadioweeklyFlag2(false);
            //   this.setState({ dropdownWeeklyFlag: true, radioweeklyFlag1: true, radioweeklyFlag2: false });
        } else if (e.target.value === 'radiovalueweekly2') {
            setDropdownWeeklyFlag(false);
            setRadioweeklyFlag1(false);
            setRadioweeklyFlag2(true);
            //   this.setState({ dropdownWeeklyFlag: false, radioweeklyFlag1: false, radioweeklyFlag2: true });
        }
    }
    function calendarCheckedChange(e) {
        setCalendarChecked(e.target.checked);
        // this.setState({ calendarChecked: e.target.checked });
        if (e.target.checked) {
            setCalendarcheckedvalueflag(false);
            //   this.setState({ calendarcheckedvalueflag: false });
        } else {
            setCalendarcheckedvalueflag(true);
            //   this.setState({ calendarcheckedvalueflag: true });
        }
    }
    function failFastChange(e, index) {
        let tasksArray = [...tasksArray];
        tasksArray[index].fail_fast_on_any_errors = e.target.checked;
        setTasksArray(tasksArray);
        // this.setState({ tasksArray: tasksArray });
    }
    function handleCalendarNameChange(e) {
        setCalendarName(e.target.value);
    }

    const handleNext = () => {
        if (validateForm()) {
            setActiveStep((prevActiveStep) => prevActiveStep + 1);
        }
        setHideBack(true);
    }

    const handleBack = () => {
        setActiveStep((prevActiveStep) => prevActiveStep - 1);
        if (activeStep <= 5) {
            setHide(true);
        }
        if (activeStep !== 0) {
            setHideBack(true);
        }
    };

    const handleReset = () => {
        setActiveStep(0);
        if (activeStep <= 5) {
            setHide(true);
        }
    };

    return (
        <div className="customized-stepper">
            <div className="customized-stepper-header">
                <Breadcrumb noTrailingSlash aria-label="Page navigation">
                    <BreadcrumbItem href='/homepage'>
                        {home}
                    </BreadcrumbItem>
                    <BreadcrumbItem className="title" href="#" isCurrentPage={true}>
                        {addSchedule}
                    </BreadcrumbItem>
                </Breadcrumb>
                <div className="action-items">
                    <Button kind="tertiary" onClick={handleReset}>{Cancel}</Button>
                    {hideBack && <Button kind="secondary" onClick={handleBack}>{activeStep === 0 ? setHideBack(false) : Back}</Button>}
                    {hide && <Button onClick={handleNext}>{activeStep === 5 ? setHide(false) : Next}</Button>}
                </div>
            </div>
            <Tile>
                <div className="stepper-container">
                    <Stepper alternativeLabel activeStep={activeStep}>
                        {steps.map((label) => (
                            <Step key={label}>
                                <StepLabel>{label}</StepLabel>
                            </Step>
                        ))}
                    </Stepper>
                    <div>
                        {getStepContent(activeStep)}
                    </div>
                </div>
            </Tile>
        </div>
    );
}